import logo from './logo.svg';
import './App.css';
import Navbar from './components/Navbar';
import Home from './pages/Home';
import AllRoutes from './AllRoutes';

function App() {
  return (
    <div className="App">
     <AllRoutes/>
    </div>
  );
}

export default App;
